import * as React from "react";
import { useEffect, useState } from "react";
import { Route } from "react-router-dom";
import { useSelector } from "react-redux";
import { ApplicationState } from "../store";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import PageFooter from "../components/PageFooter";
import Footer from "../PssLanding/components/Footer";
interface IDefaultProps {
    component: any;
    path?: string;
    exact?: boolean;
}

const LandingPageLayout: React.SFC<IDefaultProps> = (props) => {
 
    const [secondaryLogo, setSecondaryLogo] = useState("");
    const [partnerName, setPartnerName] = useState("");
    const partnerDisplayName: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );
    useEffect(() => {
        let secondaryText = brandingOptions.secondaryText;
        if (secondaryText.includes('<img')) {
            if (secondaryText.indexOf('alt=') === -1) {
                secondaryText = brandingOptions.secondaryText.replace('<img', '<img alt="logo"');
                setSecondaryLogo(secondaryText);
            }
        }
    }, []);
    const { component: Component, ...rest } = props;

    //Old Header

    const loggedInActiveAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount ? state.loggedInUser.activeAccount : null
    );
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );

    const { i18n: i18nLang } = useTranslation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    let partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const partnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : ""
    );
    const phoneNumberlink = `tel:${partnerPhoneNumber}`;
    let language =
        !!partnerLanguageOptions && partnerLanguageOptions.length > 1
            ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language").length > 0
                ? !!document.cookie
                    .split(";")
                    .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                    .split("=")[1]
                    ? document.cookie
                        .split(";")
                        .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                        .split("=")[1]
                    : "en"
                : "en"
            : "en";
    const isMetLifePartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2573
                ? true
                : false
            : false
    );

    useEffect(() => {
        language =
            document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language").length > 0
                ? !!document.cookie
                    .split(";")
                    .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                    .split("=")[1]
                    ? document.cookie
                        .split(";")
                        .filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language")[0]
                        .split("=")[1]
                    : "en"
                : "en";
        i18nLang.changeLanguage(language);
    }, [document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() === "user_prefered_language").length > 0]);

    useEffect(() => {
        if (partnerId === 2649) {
            setPartnerName("Transunion");
        } else {
            setPartnerName(partnerDisplayName);
        }
    }, [partnerId])

    const brandingOptions = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration?.partnerConfig?.brandingOption?.imagePath) {
            return {
                imagePath: state.configurationState.configuration?.partnerConfig?.brandingOption?.imagePath,
                associationText: state.configurationState.configuration?.partnerConfig?.brandingOption?.associationText,
                secondaryText: state.configurationState.configuration?.partnerConfig?.brandingOption?.secondaryText,
                originalSiteUrl: state.configurationState.configuration?.partnerConfig?.originSiteUrl,
            };
        } else {
            return {
                imagePath: "",
                associationText: "",
                secondaryText: "",
                originalSiteUrl: "",
            };
        }
    });

    return (
        <Route
            {...rest}
            render={(matchProps) => (
                <React.Fragment>
                            <header>
                                {/* <a className="skip-main" href="#content">Skip to Main Content</a> */}
                                <div className="l-page-container">
                                    <div className={renderSiteInIFrame ? "" : "row between-xs full-width"} style={{ display: renderSiteInIFrame ? "none" : "" }}>
                                        <div className="col-xs flex-grow-null">
                                            <div className="row middle-xs">
                                                {Boolean(brandingOptions?.imagePath) && (
                                                    <div className="col-no-gutter hide-mobile">
                                                        <div className="logo-container">
                                                            {(!loggedInActiveAccount || !loggedInActiveAccount.accountType) && isLife360PartnerId ? (
                                                                <a href={"#"} onClick={(e) => e.preventDefault()} title="Go to Homepage" className="logo-link">
                                                                    <img
                                                                        src={brandingOptions?.imagePath}
                                                                        alt={isMetLifePartnerId ? "MetLife Legal Plans Logo" : `${partnerName} Logo`}
                                                                    />
                                                                </a>
                                                            ) : (
                                                                (!loggedInActiveAccount || !loggedInActiveAccount.accountType) && (
                                                                    <a href={brandingOptions.originalSiteUrl ? ("https://" + brandingOptions.originalSiteUrl) : window.location.href} title="Go to Homepage" className="logo-link">
                                                                        <img
                                                                            src={brandingOptions?.imagePath}
                                                                            alt={isMetLifePartnerId ? "MetLife Legal Plans Logo" : `${partnerName} Logo`}
                                                                        />
                                                                    </a>
                                                                )
                                                            )}
                                                            {loggedInActiveAccount && loggedInActiveAccount.accountType && (
                                                                <a href="dashboard" title="Go to Homepage" className="logo-link">
                                                                    <img
                                                                        src={brandingOptions?.imagePath}
                                                                        alt={isMetLifePartnerId ? "MetLife Legal Plans Logo" : `${partnerName} Logo`}
                                                                    />
                                                                </a>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="col-no-gutter hide-mobile">
                                                    <div className="secondary-container">
                                                        <div className="secondary-text">{brandingOptions?.associationText}</div>
                                                        <div className="secondary-logo">{secondaryLogo.length ? parse(secondaryLogo || "", {}) : parse(brandingOptions?.secondaryText || "", {})}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs flex-grow-null">
                                            <div className="user-container">
                                                <div className="m-pop-under">
                                                    <ul className="list-reset list-inline">
                                                        <li style={{ margin: "10px" }}>
                                                            <strong>
                                                        <a className="header-link" href="/app/Login" onClick={() => { window.addToDataLayer({ event: "Header Secure Login" }); }}>SECURE LOGIN
                                                                </a>
                                                            </strong>
                                                        </li>
                                                        <li role="presentation">
                                                            <div className="partner-number">
                                                                <a href={phoneNumberlink} className="header-link">
                                                                    {partnerPhoneNumber}
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </header>

                    <Component {...matchProps} />
                    {!renderSiteInIFrame && partnerId ? <PageFooter />
                        : <Footer />}
                </React.Fragment>
            )}
        />
     
    );
};

export default LandingPageLayout;
